/**
 * Return true is the object contains at least on of given keys or all keys if strict is true
 * @param obj targeted object
 * @param keys keys to look in the given object
 * @param strict optional boolean
 */
export const containsKeys = (
  obj: any,
  keys: string[],
  strict?: boolean
) => {
  let count = 0;
  for (const key of keys) {
    if (Object.keys(obj).includes(key)) {
      count += 1;
      if (strict !== true) {
        return true;
      }
    }
  }
  if (strict === true && count === keys.length) {
    return true;
  } else {
    return false;
  }
};
